import styled from "styled-components";

export const LoginPageWrapperStyled = styled.div`
  .wrapper-content {
    display: flex;
    justify-content: center;
    height: 100vh;
    font-family: OpenSansSemiBold;

    .content-container {
      .sign-up-container {
        .ant-space {
          justify-content: center;
        }
        .sign-up-btn {
          font-size: 18px;
          font-family: OpenSansSemiBold;
          color: ${({ theme }): string => theme.textColors.BLUE_105};
        }
      }
    }
  }
`;
